import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import API_BASE from "../config/api";

export default function WebContactMe() {
    const user = JSON.parse(localStorage.getItem("user"));
    const personaluid = user?.personaluid;
    const fullName = user?.fullname || "User";

    const [domain, setDomain] = useState("");
    const [addresses, setAddresses] = useState("");

    const showToast = (message, icon) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: icon,
            title: message,
            showConfirmButton: false,
            timer: 1500
        });
    };

    // Load existing addresses
    useEffect(() => {
        fetch(`${API_BASE}/api/get_webcontact.php?personaluid=${personaluid}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setDomain(data.domain || "");
                    setAddresses(data.data?.addresses || "");
                }
            });
    }, [personaluid]);

    const handleChange = (e) => {
        setAddresses(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!addresses) {
            showToast("Please enter your full address", "warning");
            return;
        }

        const fd = new FormData();
        fd.append("personaluid", personaluid);
        fd.append("domain", domain);
        fd.append("addresses", addresses);

        fetch(`${API_BASE}/api/save_webcontact.php`, {
            method: "POST",
            body: fd
        })
            .then(res => res.json())
            .then(data => {
                showToast(data.message, data.success ? "success" : "error");
            });
    };

    return (
        <div className="container-fluid px-4 py-3">

            {/* Page Header */}
            <div
                className="rounded p-3 mb-3 shadow-sm"
                style={{
                    background: "linear-gradient(135deg, #e8f0ff, #fefefe)",
                    borderLeft: "6px solid #4a90e2"
                }}
            >
                <h5 className="fw-bold text-dark mb-1">Website - Contact Me</h5>
                <p className="text-secondary mb-0">
                    Update your website contents! of <b>{fullName}</b>
                </p>
            </div>

            {/* Contact Me Form */}
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body">

                    <form autoComplete="off" onSubmit={handleSubmit}>
                        <input type="hidden" name="domain" value={domain} />

                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <label className="form-label fw-semibold">
                                    Full Address Detail <span className="text-danger">*</span>
                                </label>

                                <textarea
                                    name="addresses"
                                    className="form-control form-control-sm"
                                    placeholder="Full address detail"
                                    rows="7"
                                    value={addresses}
                                    onChange={handleChange}
                                ></textarea>
                            </div>
                        </div>

                        {/* Submit */}
                        <div className="text-end">
                            <button
                                type="submit"
                                className="btn btn-info px-4 mt-2"
                            >
                                <i className="bi bi-cloud-upload-fill me-1"></i>
                                Update
                            </button>
                        </div>
                    </form>

                </div>
            </div>

        </div>
    );
}
